import { Component, computed as ngComputed, effect, input, linkedSignal, output, ChangeDetectionStrategy } from '@angular/core';
import { form } from '@angular/forms/signals';
import { CableCommentsDto, CableCommentsDtoOptionDto, CableDto, CableUpdateRequestDto } from '../../core/mceapi.client.generated';
import { apiOpt, appOpt, getNoneOptionDto } from '../../core/mceapi.client.helpers';
import { DebugPanelComponent } from '../../shared/components/debug-panel/debug-panel.component';
import { MceSaveCancelComponent } from '../../shared/components/mce-save-cancel/mce-save-cancel.component';
import { MceSaveCancelEvent } from '../../shared/components/mce-save-cancel/mce-save-cancel.component';
import { MceSaveCancelConfig } from '../../shared/components/mce-save-cancel/mce-save-cancel.component';
import { invalidFields, logInvalidFields } from '../../shared/functions/forms.helpers';
import { Option } from '../../shared/functions/functional';
import { CableCalculationsStore } from './cable-calculations.store';
import { EditCable, buildEditCableSchema, createEditCable, createEditCableDto } from './cable-edit.model';
import { CableCommentsComponent } from './comments/cable-comments.component';
import { CableDescriptionComponent } from './description/cable-description.component';
import {  EarthingSettingsComponent } from './earthing-settings/earthing-settings.component';
import { EarthingComponent } from './earthing/earthing.component';
import { CableEFLComponent } from './efl/cable-efl.component';
import { ExternalCpcComponent } from './external-cpc/external-cpc.component';
import { FaultSourceComponent } from './fault-source/fault-source.component';
import { CableInstallationComponent } from './installation/cable-installation.component';
import { LoadComponent } from './load/load.component';
import { CableProtectionComponent } from './protection/cable-protection.component';
import { RcdComponent } from './protection/rcd/rcd.component';
import { CableSelectionComponent } from './selection/cable-selection.component';
import { SystemVoltageComponent } from './system-voltage/system-voltage.component';
import { CableVoltageDropComponent } from './voltage-drop/cable-voltage-drop.component';
import { createCableCommentsDeltaDto } from './comments/cable-comments.model';

@Component({
  selector: 'cable-edit',
  imports: [
    CableCommentsComponent, CableDescriptionComponent, 
    SystemVoltageComponent, FaultSourceComponent,
    EarthingComponent, EarthingSettingsComponent, ExternalCpcComponent,
    LoadComponent, CableVoltageDropComponent,
    CableProtectionComponent, RcdComponent, CableSelectionComponent,
    CableInstallationComponent, CableVoltageDropComponent,
    FaultSourceComponent, CableEFLComponent,
    MceSaveCancelComponent, DebugPanelComponent],
  providers: [CableCalculationsStore],
  templateUrl: './cable-edit.component.html'
})

export class CableEditComponent {

  cable = input.required<CableDto>();
  comments = input.required<Option<CableCommentsDto>>();
  showDebugPanel = input(false)

  saveClick = output<CableUpdateRequestDto>();
  cancelClick = output();

  readonly model = linkedSignal<EditCable>(() => {
    return createEditCable(this.cable(), this.comments())();
  });

  readonly form = form(this.model, s => {
    buildEditCableSchema(s);
  });

  readonly saveCancelConfig = ngComputed<MceSaveCancelConfig>(() => ({
    save: { show: true, enable: this.form().valid() && this.form().dirty() },
    cancel: { show: true, enable: true },
    invalidFields: this.form().dirty() ? invalidFields(this.form, 'root') : []
  }));


  _ = effect(() => {
    //logDirtyFields(this.form, 'root');
    //logInvalidFields(this.form, 'root');
  });

  onSave() {

    let cable: CableDto = createEditCableDto(this.form, this.cable())();
    let comments: CableCommentsDtoOptionDto = apiOpt(createCableCommentsDeltaDto(this.form.comments)());

    this.saveClick.emit({
      cable: cable,
      comments: comments
    });

  }

  onCancel() { this.cancelClick.emit(); }

  onSaveCancelAction(event: MceSaveCancelEvent): void {
    if (event.type === 'save') {
      this.onSave();
      return;
    }

    if (event.type === 'cancel') {
      this.onCancel();
    }
  }


}
